export default {
  // exams: [],
};
